/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';

export const Title = styled.h3`
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const SubTitle = styled.h5`
@media (max-width: 480px) {
    text-align:center;
`;
